// extracted by mini-css-extract-plugin
export var arrow = "_2x-6";
export var changeItem = "_2x-3";
export var changesHeader = "_2x-1";
export var changesList = "_2x-2";
export var container = "_2x-0";
export var pathLabel = "_2x-4";
export var value = "_2x-7";
export var valuesContainer = "_2x-5";